import React from "react";

import { AddFilterBaseFunc, IFilterKeys, IFilters, RemoveFilterBaseFunc } from "models/core";
import { DashboardFilterKeys } from "models/youthCancer";
import { PrimarySiteHierarchy } from "models/youthCancer/plotdata";
import { ChartOrientation, ChartType, QoolDashChart } from "../core";
import { addHierarchyFilterFactory } from "helpers/filterHelper";
import { HierarchyBreadcrumb } from "components/common/HierarchyBreadcrumb";

interface IProps {
	plotData: PrimarySiteHierarchy.IHierarchyPlotData;
	activeFilters: IFilters<IFilterKeys>;
	addFilterFn: AddFilterBaseFunc<typeof DashboardFilterKeys>;
    removeFilterFn: RemoveFilterBaseFunc<typeof DashboardFilterKeys>;
}


export function PatientsBySiteChart(props: IProps) {

	const filterFn = (chartType: ChartType, chartOrientation: ChartOrientation) => 
		addHierarchyFilterFactory(props.addFilterFn, DashboardFilterKeys.PrimarySite.key, props.plotData, (chartType == ChartType.Pie ? p => p.data.labels[p.pointNumber].toString() : (chartOrientation == ChartOrientation.Horizontal ? p => p.y.toString() : p => p.x.toString()))); 

	return (
		<QoolDashChart
			xAxis={{ horizontalOrientation: { label: "Number of Diagnoses" }, verticalOrientation: { label: "" }  }}
			yAxis={{ horizontalOrientation: { label: "" }, verticalOrientation: { label: "Number of Diagnoses" }	}}
			chartOrder={{ horizontalOrientation: { reversed: false }, verticalOrientation: { reversed: true } }}
			defaultChartOrientation={ChartOrientation.Horizontal}
			defaultChartType={ChartType.Bar}
			chartTitle="Cancer Type"
			filterKey={""}
			plotData={[props.plotData]}
			breadcrumb={<HierarchyBreadcrumb data={props.plotData} filterKey={DashboardFilterKeys.PrimarySite.key} addFilter={props.addFilterFn} removeFilter={props.removeFilterFn} />}
			activeFilters={props.activeFilters}
			filterFn={filterFn}
			addFilterFn={props.addFilterFn}
			removeFilterFn={props.removeFilterFn}
			hoverText="Diagnoses"
			sortUnknownToEnd={true}
			chartIcons={{
				line: false
			}}
			chartDimensions={{
				chartHeightProportion: 50,
				parentColNumber: 12,
				tabColNumber: 4
			}}
		/>
	)

}
